import DeviceLayoutPage from './device-layout-page';

export default DeviceLayoutPage;